import React from "react";
import { Link } from "react-router-dom";
import { images } from "../../constants";

const policies = [
  { to: "/terms", label: "Terms and Conditions 📃" },
  { to: "/privacy", label: "Privacy Policy 🔒" },
  { to: "/eula", label: "EULA 🧑‍🏫" },
  { to: "/cookies", label: "Cookie Policy 🍪" },
  { to: "/return", label: "Return Policy 🚚" },
  { to: "/disclaimer", label: "Disclaimer 📜" },
  { to: "/acceptableuse", label: "Acceptable Use Policy ✔️" },
];

const Navbar = () => {
  return (
    <div className="mb-4 border-b border-border_soft pb-10">
      <Link to="/" className="inline-block">
        <img src={images.logoEn} alt="Klassekartgenerator" className="h-11 w-auto" />
      </Link>

      <h1 className="mt-2 text-[38px] font-bold leading-tight tracking-[-1px] text-ink">
        Terms &amp; Policies
      </h1>
      <p className="mt-3 max-w-[560px] text-[15px] leading-relaxed text-muted">
        The following pages contain the legal requirements for the use of{" "}
        <a href="https://klassekartgenerator.no" className="font-semibold text-orange_deep hover:underline">
          klassekartgenerator.no
        </a>{" "}
        and our app{" "}
        <a href="https://app.klassekartgenerator.no" className="font-semibold text-orange_deep hover:underline">
          app.klassekartgenerator.no
        </a>
        . Do not hesitate to contact us at{" "}
        <a href="mailto:hei@klassekartgenerator.no" className="font-semibold text-orange_deep hover:underline">
          hei@klassekartgenerator.no
        </a>{" "}
        with any questions.
      </p>

      <div className="mt-6 flex flex-wrap gap-2.5">
        <Link to="/" className="ds-cta h-10 px-5 text-[13px]">
          ← Back to page
        </Link>
        {policies.map((p) => (
          <Link
            key={p.to}
            to={p.to}
            className="ds-ghost h-10 px-4 text-[13px] font-semibold"
          >
            {p.label}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Navbar;
